import React, { createRef, useEffect, useState } from "react";
import { useOnScreen } from "../../components/useOnScreen";
import { Title, Wrapper } from "../../GlobalStyle";
import { ServicesWrapper } from "./Styled";
import Tilt from "react-tilted";

const SERVICE_LIST = [
  {
    title: "Minting of nfts",
    description: "Done on the Ethereum or Polygon blockchain.",
    image: require("../../images/service-bag.png"),
  },
  {
    title: "Strategic turn-key solution",
    description:
      "Industry Research, Project Management, Promotion and Troubleshooting. We strategise yout entire campaign with you.",
    image: require("../../images/service-pos.png"),
  },
  {
    title: "Smart contracts",
    description:
      "Customised integration of smart contracts for NFTs. We use the latest standards and security measures to ensure security for your project and IPs.",
    image: require("../../images/service-present.png"),
  },
  {
    title: "Education",
    description:
      "A range of beginner-advanced workshops for individuals and corporates that are interested to learn more about the web3 space!",
    image: require("../../images/service-diamond.png"),
  },
  {
    title: "NFT as a Digital certification",
    description:
      "Supported by blockchain, NFT can certify identification & property ownership of digital assets with high security. Digital Assets such as artwork and song can be rented while property right has been protected.",
    image: require("../../images/service-basket.png"),
  },
  {
    title: "Pr, Promotion and social media management",
    description:
      "With our established network of media partners and expertise in NFT marketing, we offer dedicated services such as customised Twitter and discord  community management.",
    image: require("../../images/service-megaphone.png"),
  },
  {
    title: "Design and style of nfts ",
    description:
      "Unsure of how to create your artwork as a picture, GIF or animation? We help you decide and work on them for you! Outsource your design team to us anytime!",
    image: require("../../images/service-trolley.png"),
  },
];

function ServiceItem({ title, description, picture, isVisible, delay }) {
  const animateRef = createRef();
  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    if (isVisible) {
      animateRef.current = setTimeout(() => {
        setIsShow(true);
      }, delay);
    } else {
      setIsShow(false);
    }

    return () => clearTimeout(animateRef.current);
  }, [isVisible]);

  return (
    <div className={`service-item ${isShow ? "active" : ""}`}>
      <Tilt className="Tilt" max={50}>
        <div className="Tilt-inner">
          <img src={picture} alt="Service" />
        </div>
      </Tilt>
      <div className="title">{title}</div>
      <p>{description}</p>
    </div>
  );
}

function Services() {
  const containerRef = createRef();
  const isVisible = useOnScreen(containerRef);

  return (
    <ServicesWrapper id="services" ref={containerRef}>
      <Wrapper>
        <Title>Types of Services</Title>
        <div className="services-container">
          {SERVICE_LIST.map((service, index) => {
            const { title, description, image } = service;
            return (
              <ServiceItem
                title={title}
                description={description}
                picture={image}
                isVisible={isVisible}
                delay={index * 100}
                key={`service${index}`}
              />
            );
          })}
        </div>
      </Wrapper>
    </ServicesWrapper>
  );
}
export default Services;
